import { render, staticRenderFns } from "./fast-query.vue?vue&type=template&id=5d1df492"
import script from "./fast-query.vue?vue&type=script&lang=ts"
export * from "./fast-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports